import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography, Paper } from '@material-ui/core';
import * as Actions from './store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';

const localizer = BigCalendar.momentLocalizer(moment);

const styles = theme => ({
    root: {}
});

class ScheduledCourseAgenda extends Component {
    componentWillMount = () => {
        this.props.getAgenda(this.props.company_course_id);
    }
    
    // handleRowClick = (student_quiz_id) => {
    //     this.props.history.push(`/quiz/grader/${student_quiz_id}`);
    // }

    render() {
        const { events, classes }      = this.props;
        const allViews = ['agenda']
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">
                            
                        </Typography>
                    </Toolbar>
                </AppBar>
                <BigCalendar
                    views={allViews}
                    defaultView='agenda'
                    localizer={localizer}
                    events={events}
                    // components={{
                    //     toolbar: 'none'
                    // }}
                />
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAgenda: Actions.getAgenda
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
        events: scheduledCourseApp.scheduledCourses.agenda
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduledCourseAgenda)));




// WEBPACK FOOTER //
// src/main/content/scheduled_course/ScheduledCourseAgenda.js